<!--
  Created 05.01.2023
  Originated from Tailwind UI component: Forms, Select Menus, WithSecondaryText
  https://tailwindui.com/components/application-ui/forms/select-menus#component-71680e7ae17adab2886761e3e2390f6a
-->
<template>
  <Listbox
    v-model="selected"
    as="div">
    <ListboxLabel
      v-if="label"
      class="block text-sm font-medium"
      :class="labelTextColor">
      {{ label }}
    </ListboxLabel>
    <div class="relative mt-1">
      <ListboxButton
        class="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10
      text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm">
        <span class="inline-flex w-full truncate">
          <span class="truncate">{{ Object.values(selected)[0] }}</span>
          <span class="ml-2 truncate text-gray-500">{{ Object.values(selected)[1] }}</span>
        </span>
        <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronDownIcon
            class="h-5 w-5 text-gray-400"
            aria-hidden="true" />
        </span>
      </ListboxButton>

      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <ListboxOptions
          class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base
        shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
          <ListboxOption
            v-for="item in items"
            :key="item"
            v-slot="{ active, selected }"
            as="template"
            :value="item">
            <li :class="[active ? 'bg-indigo-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9']">
              <div class="flex">
                <span :class="[selected ? 'font-semibold' : 'font-normal', 'truncate']">{{ Object.values(item)[0] }}</span>
                <span :class="[active ? 'text-indigo-200' : 'text-gray-500', 'ml-2 truncate']">{{ Object.values(item)[1] }}</span>
              </div>

              <span
                v-if="selected"
                :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                <CheckIcon
                  class="h-5 w-5"
                  aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script setup>
import { ref } from 'vue';
import {
  Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions,
} from '@headlessui/vue';
import {
  CheckIcon, ChevronDownIcon,
} from '@heroicons/vue/24/solid';

const props = defineProps({
  items: {
    type: Array,
    required: true,
    default: () => [
      {
        primary: 'First text in black', secondary: 'Second text in light gray',
      },
      {
        name: 'Ola Nordmann', company: 'Telenor AS',
      },
      {
        fullName: 'Kari Nordmann', corporation: 'DNB ASA',
      },
    ],
  },
  label: {
    type: String,
    default: '',
    required: false,
  },
  labelTextColor: {
    type: String,
    default: 'text-gray-700',
    required: false,
  },
});

const selected = ref(props.items[0]);

</script>
